import React from 'react';

const DeleteButton = ({inactive, click}) => {
  return (
      <a className={'trash-btn' + (inactive ? ' trash-btn--inactive' : '' )} onClick={() => click()}>
        <svg>
            <use href='/ui/images/sprites/be-group.svg#trashbin'></use>
        </svg>
      </a>
  );
};

export default DeleteButton;